/**
 * @generated SignedSource<<e0e6f605cdd71d5a608aa6873dc1a7af>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type BrandMessageTaskDeactivateInput = {
  id: string;
};
export type BrandMessageTaskId_brandMessageTaskDeactivateMutation$variables = {
  input: BrandMessageTaskDeactivateInput;
};
export type BrandMessageTaskId_brandMessageTaskDeactivateMutation$data = {
  readonly brandMessageTaskDeactivate: {
    readonly id: string;
    readonly isActive: boolean;
  };
};
export type BrandMessageTaskId_brandMessageTaskDeactivateMutation = {
  response: BrandMessageTaskId_brandMessageTaskDeactivateMutation$data;
  variables: BrandMessageTaskId_brandMessageTaskDeactivateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "BrandMessageTask",
    "kind": "LinkedField",
    "name": "brandMessageTaskDeactivate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isActive",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "BrandMessageTaskId_brandMessageTaskDeactivateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BrandMessageTaskId_brandMessageTaskDeactivateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "1ede6120fc6cc33ab99357e328ce881c",
    "id": null,
    "metadata": {},
    "name": "BrandMessageTaskId_brandMessageTaskDeactivateMutation",
    "operationKind": "mutation",
    "text": "mutation BrandMessageTaskId_brandMessageTaskDeactivateMutation(\n  $input: BrandMessageTaskDeactivateInput!\n) {\n  brandMessageTaskDeactivate(input: $input) {\n    id\n    isActive\n  }\n}\n"
  }
};
})();

(node as any).hash = "b61ad207593680468ccc0f25e79abe52";

export default node;
